var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex column gap10"},[_c('h2',[_vm._v(_vm._s(_vm.$t('distributeLocales.reports')))]),_c('ItemSearchList',{staticClass:"flex-1 height-all container report-list",attrs:{"itemsData":_vm.allReleasesData,"initFilterBy":_vm.releaseFilterBy,"itemDetailesPageName":"ReleaseDetails","singlePreviewCmp":_vm.ReleasePreview,"filterByCmp":_vm.ReleaseFilter,"dontRoute":true,"layoutMode":"grid","propsToPass":{
      inludeSearchInput: true,
      reportMode: true
    }},on:{"filter":_vm.getAllReleases}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }